import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
registerLicense('Mgo+DSMBMAY9C3t2VVhhQlFac11JXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkBiUH9WdXxVT2ZdVkY=');
fetch('assets/config/configProd.json')
  .then((response) => {
    return response.json();
  })
  .then(() => {
    if (environment.production) {
      enableProdMode();
      console.log = () => {};
      if (window) {
        window.console.log = () => {};
      }
    }
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
